module.exports = __webpack_public_path__ + "img/20230109172720.26a3186e.jpg";